import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { FAQ_ITEMS } from "../data/worlds";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export const FAQ = ({ compact = false }) => (
  <section className="py-24 sm:py-32" id="faq" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-5 lg:px-8">
      <Reveal className="text-center mb-12">
        <p className="eyebrow-label mb-5">Gut zu wissen</p>
        <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08]">
          Häufige <em style={{ color: "var(--terra)" }}>Fragen.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQ_ITEMS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="card-soft !rounded-2xl px-6 border-b-0"
              data-testid={`faq-accordion-item-${i + 1}`}
            >
              <AccordionTrigger className="text-left font-display text-base sm:text-lg font-medium hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[color:var(--ink-muted)] text-[15px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      {!compact && (
        <Reveal delay={0.15} className="text-center mt-10">
          <p className="text-sm text-[color:var(--ink-muted)]">
            Noch Fragen?{" "}
            <Link to="/kontakt" className="font-semibold underline" style={{ color: "var(--terra)" }} data-testid="faq-contact-link">
              Schreib uns gerne.
            </Link>
          </p>
        </Reveal>
      )}
    </div>
  </section>
);
